import React from 'react';

import { FilterChipList, FiltersReport, type FiltersReportProps } from '@pkg/components/filters';

import { useNFTsFiltersStore } from '@app/store/zustand/profile-page/useNFTsFiltersStore.ts';

import { AppliedChip } from './AppliedChip.tsx';

export interface NftFiltersReportProps {
    resultsCount?: FiltersReportProps['resultsCount'];
}

export function NftFiltersReport({ resultsCount = 0 }: NftFiltersReportProps) {
    const { currentFilters, resetFilters } = useNFTsFiltersStore();

    const currentKeys = currentFilters.keys();
    const selectedFilters = [...currentKeys].filter((key) => {
        const values = currentFilters.get(key);
        return Boolean(values?.length);
    });

    const chipsMarkup = selectedFilters.map((filterKey) => (
        <FilterChipList.Item key={filterKey}>
            <AppliedChip filterKey={filterKey} />
        </FilterChipList.Item>
    ));

    const listMarkup = chipsMarkup.length ? <FilterChipList>{chipsMarkup}</FilterChipList> : null;

    return (
        <FiltersReport resultsCount={resultsCount} onClear={resetFilters}>
            {listMarkup}
        </FiltersReport>
    );
}
